module.exports = __webpack_public_path__ + "img/lythqjt.bb6400ab.png";